import { PriceInfoSection } from "../components/PriceInfoSection";

interface LeadPriceInfoProps {
  expectedPrice: string;
  purchasePrice: string;
  marketPrice: string;
}

export const LeadPriceInfo = ({
  expectedPrice,
  purchasePrice,
  marketPrice,
}: LeadPriceInfoProps) => {
  return (
    <PriceInfoSection
      expectedPrice={expectedPrice}
      purchasePrice={purchasePrice}
      marketPrice={marketPrice}
    />
  );
};
